import { forwardRef } from 'react';
import type { LucideIcon, LucideProps } from 'lucide-react';

/** Simple dining / cafe table (POS / floor plan “tables”). */
export const DiningTableIcon = forwardRef<SVGSVGElement, LucideProps>(function DiningTableIcon(
  { size = 24, strokeWidth = 2, className, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path d="M5 9h14M8 9v11M16 9v11" />
    </svg>
  );
}) as LucideIcon;

DiningTableIcon.displayName = 'DiningTableIcon';
